import React from 'react';

const Percent_work = () => {
    return (
        <section id="percent_work">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="percent_work">
                <div class="card-1">
                  <div class="box">
                    <div class="percent">
                      <svg>
                        <circle cx="70" cy="70" r="70"></circle>
                        <circle cx="70" cy="70" r="70"></circle>
                      </svg>
                      <div class="number">
                        <h2>
                          90<span>%</span>
                        </h2>
                      </div>
                      <h2 class="text-pro">
                        Html / Css
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="percent_work">
                <div class="card-2">
                  <div class="box">
                    <div class="percent">
                      <svg>
                        <circle cx="70" cy="70" r="70"></circle>
                        <circle cx="70" cy="70" r="70"></circle>
                      </svg>
                      <div class="number">
                        <h2>
                          95<span>%</span>
                        </h2>
                      </div>
                      <h2 class="text-pro">Bootstrap</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="percent_work">
                <div class="card-3">
                  <div class="box">
                    <div class="percent">
                      <svg>
                        <circle cx="70" cy="70" r="70"></circle>
                        <circle cx="70" cy="70" r="70"></circle>
                      </svg>
                      <div class="number">
                        <h2>
                          80<span>%</span>
                        </h2>
                      </div>
                      <h2 class="text-pro">JavaScript</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="percent_work">
                <div class="card-4">
                  <div class="box">
                    <div class="percent">
                      <svg>
                        <circle cx="70" cy="70" r="70"></circle>
                        <circle cx="70" cy="70" r="70"></circle>
                      </svg>
                      <div class="number">
                        <h2>
                          95<span>%</span>
                        </h2>
                      </div>
                      <h2 class="text-pro">Figma / XD</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="percent_work">
                <div class="card-5">
                  <div class="box">
                    <div class="percent">
                      <svg>
                        <circle cx="70" cy="70" r="70"></circle>
                        <circle cx="70" cy="70" r="70"></circle>
                      </svg>
                      <div class="number">
                        <h2>
                          90<span>%</span>
                        </h2>
                      </div>
                      <h2 class="text-pro">React JS</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="percent_work">
                <div class="card-6">
                  <div class="box">
                    <div class="percent">
                      <svg>
                        <circle cx="70" cy="70" r="70"></circle>
                        <circle cx="70" cy="70" r="70"></circle>
                      </svg>
                      <div class="number">
                        <h2>
                          85<span>%</span>
                        </h2>
                      </div>
                      <h2 class="text-pro">Axios / API</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="percent_work">
                <div class="card-7">
                  <div class="box">
                    <div class="percent">
                      <svg>
                        <circle cx="70" cy="70" r="70"></circle>
                        <circle cx="70" cy="70" r="70"></circle>
                      </svg>
                      <div class="number">
                        <h2>
                          90<span>%</span>
                        </h2>
                      </div>
                      <h2 class="text-pro">NodeJS</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="percent_work">
                <div class="card-8">
                  <div class="box">
                    <div class="percent">
                      <svg>
                        <circle cx="70" cy="70" r="70"></circle>
                        <circle cx="70" cy="70" r="70"></circle>
                      </svg>
                      <div class="number">
                        <h2>
                          80<span>%</span>
                        </h2>
                      </div>
                      <h2 class="text-pro">Mongo db</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
};

export default Percent_work;